<template>
  <div class="form-group">
    <label>{{ label }}</label>
    <el-upload
      action=""
      ref="upload-location-image"
      :limit="2"
      :file-list="fileList"
      list-type="picture-card"
      accept=" .jpg, .jpeg, .png, .svg, .webp"
      :on-change="handleChange"
      :on-exceed="handleExceed"
      :on-remove="handleRemove"
      :auto-upload="false">
      <img src="/static/img/icons/icon-plus-primary.png">
      <div class="el-upload__tip" slot="tip">{{$t('validations.pictureSize')}}</div>
    </el-upload>
  </div>
</template>
<script>
  import swal from 'sweetalert2'

  export default {
    name: 'image-input',
    inheritAttrs: false,
    props: {
      location: Object,
      label: String,
      image: String,
      imageField: String
    },
    data () {
      return {
        apiUrl: ''
      }
    },
    computed: {
      fileList () {
        if (!this.image) return []
        return [{
          name: this.imageField || this.label || 'image',
          url: this.image
        }]
      }
    },
    created () {
      this.apiUrl = process.env.API_BASE_URL
    },
    methods: {
      beforeUpload (file, fileList) {
        const isOkSize = file.size / 1024 / 1024 < 5
        var self = this
        if (!isOkSize) {
          swal({
            toast: true,
            type: 'warning',
            title: self.$t('validations.pdfSizeExceed'),
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000
          }).then(() => {})
          .catch(() => {})
        }
        return isOkSize
      },
      handleChange (file, fileList) {
        const isOkSize = file.size / 1024 / 1024 < 25
        var self = this
        if (!isOkSize) {
          swal({
            toast: true,
            type: 'warning',
            text: self.$t('validations.pdfSizeExceed'),
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000
          }).then(() => {})
          .catch(() => {})
          this.$refs['upload-location-image'].clearFiles()
        } else {
          self.getBase64(file.raw).then(
            (base64enc) => {
              self.$bus.$emit('upload-location-image', {id: this.location.id, file: base64enc, field: this.imageField})
            }
          )
        }
      },
      handleRemove (file, fileList) {
        this.$bus.$emit('remove-upload-location-image', {id: this.location.id, field: this.imageField})
      },
      handleExceed (files, fileList) {
        var self = this
        swal({
          toast: true,
          text: self.$t('validations.removePhoto'),
          type: 'warning',
          position: 'top-end',
          showConfirmButton: true
        })
      }
    }
  }
</script>

<style>
  p {
    overflow: hidden;
  }
  .mb-5 {
    margin-bottom: 2rem;
  }
  .ml-4 {
    margin-left: 1.25rem;
  }
  .px-0 {
    padding-left: 0;
    padding-right: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/UIComponents/Inputs/ImageInput.vue